import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {ellipsis} from '../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {emojiToDefinition} from '../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {Emoji} from '../../components/common/emoji/emoji';
import {HighlightTypesEnum} from '../../models/api/highlightBaseModel';
import {TagModel} from '../../models/api/tagModel';
import {baseEmojiValidationMap} from '../../services/emojis/emojis';

/*
 * Props.
 */

interface SettingsTagsHeaderTitleProps {
  tag?: TagModel;
  isEditingATag?: boolean;
}

/*
 * Style.
 */

const StyledTagName = styled.span`
  ${ellipsis()};
  padding-right: 20px;
`;

/*
 * Component.
 */

export const SettingsTagsHeaderTitle: FC<SettingsTagsHeaderTitleProps> = (props) => {
  const theme = useUserTheme();
  const {tag, isEditingATag} = props;

  if (!tag && !isEditingATag) {
    return <Trans id="settingstags-tags">Tags</Trans>;
  }

  if (!tag && isEditingATag) {
    return <Trans id="settingstags-newtag">Add tag</Trans>;
  }

  if (!tag) {
    return null;
  }

  if (tag.type === HighlightTypesEnum.EMOJI) {
    const definition = emojiToDefinition(tag.highlightEmoji, baseEmojiValidationMap);
    if (definition) {
      return (
        <>
          <Emoji {...definition} size={20} />
          <StyledTagName>{tag.name}</StyledTagName>
        </>
      );
    }
  }

  const iconColor =
    tag.type === HighlightTypesEnum.COLOR ? theme.palette[tag.highlightColor].shade40 : theme.greys.shade70;

  return (
    <>
      <Icon color={iconColor} name="tagFilled" />
      <StyledTagName>{tag.name}</StyledTagName>
    </>
  );
};
